import { BaseAuthParams, PlatformMeetingParams, WebexParams, TeamsParams } from '../types';

import { MeetingPlatform } from '@/utils/meetingPlatforms';

export const parseBaseAuthParams = (searchParams: URLSearchParams): BaseAuthParams => ({
  sessionId: searchParams.get('sessionId'),
  meetingUrl: searchParams.get('meetingUrl') || '',
  platform: (searchParams.get('platform') || '').toLowerCase() as MeetingPlatform,
});

export const parseWebexParams = (searchParams: URLSearchParams): WebexParams | null => {
  const platform_meeting_id = searchParams.get('webex_platform_meeting_id') || '';
  const platform_org_id = searchParams.get('webex_platform_org_id') || '';

  return platform_meeting_id && platform_org_id
    ? {
        platform_meeting_id,
        platform_org_id,
        platform: 'webex',
      }
    : null;
};

export const parseTeamsParams = (searchParams: URLSearchParams): TeamsParams | null => {
  const tenantId = searchParams.get('teams_tenantId') || '';
  const userObjectId = searchParams.get('teams_userObjectId') || '';
  const meetingChatId = searchParams.get('teams_meetingChatId') || '';

  return tenantId && userObjectId && meetingChatId
    ? {
        tenantId,
        userObjectId,
        meetingChatId,
        platform: 'teams',
      }
    : null;
};

export const parsePlatformParams = (
  searchParams: URLSearchParams,
  platform: MeetingPlatform,
): PlatformMeetingParams => {
  switch (platform) {
    case 'webex':
      return parseWebexParams(searchParams);
    case 'teams':
      return parseTeamsParams(searchParams);
    default:
      return null;
  }
};